"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InjectionPosition = void 0;
var InjectionPosition;
(function (InjectionPosition) {
    InjectionPosition["TopLeft"] = "top-left";
    InjectionPosition["TopRight"] = "top-right";
    InjectionPosition["BottomLeft"] = "bottom-left";
    InjectionPosition["BottomRight"] = "bottom-right";
    InjectionPosition["SideBySide"] = "side-by-side";
})(InjectionPosition = exports.InjectionPosition || (exports.InjectionPosition = {}));
